var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('send-afip-tickets'),_c('b-modal',{attrs:{"size":"lg","id":"afip-reenviar-facturas","title":"Facturas no autorizadas","hide-footer":""}},[_c('h5',[_vm._v(" Ocurrieron problemas al autorizar las siguientes ventas ")]),_c('p',[_vm._v(" Vuelva a enviar a autorizar todas estas ventas ")]),_c('list-sales'),_c('btn')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }